(function () {

    'use strict';

    angular.module('Services').service('AccountingInvoiceImportTableService', AccountingInvoiceImportTableService);

    AccountingInvoiceImportTableService.$inject = [
        'AccountingService',
        'TableLiteFactory',
        '$filter',
        '$route',
        'toastr',
        'Units'
    ];

    function AccountingInvoiceImportTableService(
        AccountingService,
        TableLiteFactory,
        $filter,
        $route,
        toastr,
        Units
    ){
        return function (invoiceId, confirm, headers) {
            const tableData = {
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Confirm',
                        tooltip: 'Confirm',
                        onClick: function () {
                            this.loadingIndicator = true;
                            this.label = "Confirming...";
                            confirm();
                        }
                    }, {
                        class: 'btn-default',
                        label: 'Cancel',
                        tooltip: 'Cancel',
                        onClick: function () {
                            AccountingService.Reconciliations.clearShipments();
                            $route.reload();
                        }
                    }]
                },
                config: {
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noFooter: true,
                    colMinWidth: '135px'
                },
                headers: headers,
                data: []
            };

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: AccountingService.Reconciliations.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData({content: data});
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    console.log(err);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/

                tableActions.initializeTableData(data);
                if (!data) {
                    return null;
                }

                angular.forEach(data.content, function (shipment) {
                    const row = angular.copy(shipment);
                    row.consignmentNumber = row.shipment.consignmentId;
                    row.invoiceDate = $filter('bbaDate')(row.invoiceDate);
                    row.frieghtCharge = $filter('bbaCurrency')(row.frieghtCost, shipment.currency);
                    row.fuelCharge = $filter('bbaCurrency')(row.fuelCharge, shipment.currency);
                    row.otherCharges = $filter('bbaCurrency')(row.otherCharges, shipment.currency);
                    row.totalChargeExTax = $filter('bbaCurrency')(row.totalChargeExcludingTax, row.shipment.currency);
                    row.totalIncFuelAndFeesExTax = $filter('bbaCurrency')(row.totalIncludingFuelAndFeesExcludingTax);
                    row.href = '/accounting/invoices/' + invoiceId + '/import/' + row.shipment.id;
                    tableData.data.push(row);
                });
                /*** END - Building of Data ***/
            }

            this.tableData = tableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/AccountingInvoiceImportTableService.js